<template>
  <div class="layout-videos">

      <slot name="header">
          <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
            <div class="uk-light uk-container uk-container-small uk-text-center">

                <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                <h1 class="uk-margin-small-top">{{page.title}}</h1>

                <slot name="summary">
                    <p class="uk-text-lead" v-if="page.summary">{{page.summary}}</p>
                </slot>

            </div>
          </div>
      </slot>

        <div class="uk-section uk-background-white uk-section-medium">
            <div class="uk-container">

                <div class="uk-grid uk-child-width-1-2@s uk-child-width-1-3@m" uk-grid uk-height-match="target: .uk-card-title">
                    <div v-for="photoAlbum in readPhotoAlbums.edges" :key="photoAlbum.node.urlSegment">
                        <PhotoAlbumCard :photoAlbum="photoAlbum.node" />
                    </div>
                </div>

            </div>
        </div>

  </div>
</template>

<script>
import PhotoAlbumCard from '../photos/PhotoAlbumCard.vue'
import gql from 'graphql-tag'

// GraphQL query
const readPhotoAlbumsQuery = gql`{
  readPhotoAlbums {
    edges {
      node {
        created
       	title
        urlSegment
        link
        featuredImage {
          smallSquare
        }
      }
    }
  }
}`

export default {
    props: ['page', 'parent'],
    data() {
        return {
            activeCategory: 0,
            readPhotoAlbums: [],
            loading: 0
        }
    },
    components: {
        PhotoAlbumCard
    },
    apollo: {
        readPhotoAlbums: {
            // GraphQL query
            query: readPhotoAlbumsQuery,
            // Will update the 'loading' attribute
            // +1 when a new query is loading
            // -1 when a query is completed
            loadingKey: 'loading'
        }
    }
}
</script>
